import SignUp from "../pages/SignUp";
import SignIn from "../pages/SignIn";
import Unauthorized from "../pages/403";
import RedeemCoupon from "../pages/transport/RedeemCoupon";
import OTP from "../pages/OTP";
import PassportReset from "../pages/PasswordReset";
import PassportResetConfirm from "../pages/PasswordResetConfirm";
{
  /* <Route path='*' element={<Page404 homepage='/admin/landing' />} />  */
}

const publicRoutes = [
  { path: "/signup", element: <SignUp /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/reset", element: <PassportReset /> },
  { path: "/recover_password", element: <PassportResetConfirm /> },
  { path: "/", element: <SignIn /> },
  { path: "/otp", element: <OTP /> },
  { path: "/redeem_coupon", element: <RedeemCoupon /> },
  { path: "/403", element: <Unauthorized /> },
];

export default publicRoutes;
